import { render, staticRenderFns } from "./manageAccount.vue?vue&type=template&id=d1bf42f4&scoped=true"
import script from "./manageAccount.vue?vue&type=script&lang=js"
export * from "./manageAccount.vue?vue&type=script&lang=js"
import style0 from "./manageAccount.vue?vue&type=style&index=0&id=d1bf42f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1bf42f4",
  null
  
)

export default component.exports